import { EC2Client, SpotPrice } from "@aws-sdk/client-ec2";
import { getSpotPricesByRegion } from "./getSpotPricesByRegion";
import { regions } from "../consts/regions";
import { groupSpotPriceByInstanceType } from "./groupSpotPriceByInstanceType";
import { FilterObject } from "../components/SpotInstanceTable/Filter";

export const getSpotPrices = async (
  ec2Client: EC2Client,
  instanceTypes: string[],
  filter: FilterObject,
) => {
  let spotPricesDataByRegion = await Promise.all(
    regions.map((region) =>
      getSpotPricesByRegion(region, instanceTypes, filter),
    ),
  );

  const allSpotPriceData: SpotPrice[] = spotPricesDataByRegion.reduce(
    (acc: SpotPrice[], regionSpotPriceData) => {
      acc.push(...regionSpotPriceData);
      return acc;
    },
    [],
  );

  return groupSpotPriceByInstanceType(allSpotPriceData);
};
